import * as _pako2 from "pako";
var _pako = "default" in _pako2 ? _pako2.default : _pako2;
import * as _urlJoin2 from "url-join";
var _urlJoin = "default" in _urlJoin2 ? _urlJoin2.default : _urlJoin2;
import { dew as _Dew } from "..";
import { dew as _ClientDew } from "../api/resources/records/client/Client";
import { dew as _coreDew } from "../core";
import { dew as _environmentsDew } from "../environments";
import { dew as _errorsDew } from "../errors";
import { dew as _serializationDew } from "../serialization";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  var __createBinding = exports && exports.__createBinding || (Object.create ? function (o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = {
        enumerable: true,
        get: function () {
          return m[k];
        }
      };
    }
    Object.defineProperty(o, k2, desc);
  } : function (o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
  });
  var __setModuleDefault = exports && exports.__setModuleDefault || (Object.create ? function (o, v) {
    Object.defineProperty(o, "default", {
      enumerable: true,
      value: v
    });
  } : function (o, v) {
    o["default"] = v;
  });
  var __importStar = exports && exports.__importStar || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
  };
  var __awaiter = exports && exports.__awaiter || function (thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P ? value : new P(function (resolve) {
        resolve(value);
      });
    }
    return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e) {
          reject(e);
        }
      }
      function rejected(value) {
        try {
          step(generator["throw"](value));
        } catch (e) {
          reject(e);
        }
      }
      function step(result) {
        result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  };
  var __importDefault = exports && exports.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  };
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Records = void 0;
  const pako_1 = __importDefault(_pako);
  const url_join_1 = __importDefault(_urlJoin);
  const __1 = _Dew();
  const Client_1 = _ClientDew();
  const core = __importStar(_coreDew());
  const environments = __importStar(_environmentsDew());
  const errors = __importStar(_errorsDew());
  const serializers = __importStar(_serializationDew());
  class Records extends Client_1.Records {
    /**
     * Adds records to a workbook sheet
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    insert(sheetId, request, requestOptions) {
      var _a, _b;
      return __awaiter(this, void 0, void 0, function* () {
        const body = (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.compressRequestBody) ? pako_1.default.gzip(JSON.stringify(request)) : yield serializers.records.insert.Request.jsonOrThrow(request, {
          unrecognizedObjectKeys: "strip"
        });
        const gzipHeaders = (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.compressRequestBody) ? {
          "Content-Encoding": "gzip",
          "Content-Length": body.length.toString()
        } : {};
        const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core.fetcher)({
          url: (0, url_join_1.default)((_b = yield core.Supplier.get(this._options.environment)) !== null && _b !== void 0 ? _b : environments.FlatfileEnvironment.Production, `/sheets/${yield serializers.SheetId.jsonOrThrow(sheetId)}/records`),
          method: "POST",
          headers: Object.assign({
            Authorization: yield this._getAuthorizationHeader(),
            "X-Disable-Hooks": "true",
            "X-Fern-Language": "JavaScript",
            "X-Fern-SDK-Name": "@flatfile/api",
            "X-Fern-SDK-Version": "1.5.27"
          }, gzipHeaders),
          contentType: "application/json",
          body,
          timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000
        });
        if (_response.ok) {
          return yield serializers.RecordsResponse.parseOrThrow(_response.body, {
            unrecognizedObjectKeys: "passthrough",
            allowUnrecognizedUnionMembers: true,
            allowUnrecognizedEnumValues: true,
            skipValidation: true,
            breadcrumbsPrefix: ["response"]
          });
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.statusCode) {
            case 400:
              throw new __1.Flatfile.BadRequestError(yield serializers.Errors.parseOrThrow(_response.error.body, {
                unrecognizedObjectKeys: "passthrough",
                allowUnrecognizedUnionMembers: true,
                allowUnrecognizedEnumValues: true,
                skipValidation: true,
                breadcrumbsPrefix: ["response"]
              }));
            case 404:
              throw new __1.Flatfile.NotFoundError(yield serializers.Errors.parseOrThrow(_response.error.body, {
                unrecognizedObjectKeys: "passthrough",
                allowUnrecognizedUnionMembers: true,
                allowUnrecognizedEnumValues: true,
                skipValidation: true,
                breadcrumbsPrefix: ["response"]
              }));
            default:
              throw new errors.FlatfileError({
                statusCode: _response.error.statusCode,
                body: _response.error.body
              });
          }
        }
        switch (_response.error.reason) {
          case "non-json":
            throw new errors.FlatfileError({
              statusCode: _response.error.statusCode,
              body: _response.error.rawBody
            });
          case "timeout":
            throw new errors.FlatfileTimeoutError();
          case "unknown":
            throw new errors.FlatfileError({
              message: _response.error.errorMessage
            });
        }
      });
    }
  }
  exports.Records = Records;
  return exports;
}